export default "__VITE_ASSET__CCFILWHn__"